import { useEffect } from "react";

/**
 * F-due-30 (CEO 2026-09-24) — vencimento da fatura: nasce em +30 dias, com
 * atalhos (1 semana, 15 dias, 30 dias, 2 meses) e o calendário para uma data
 * específica. Os rótulos vêm da página (cada namespace i18n tem os seus).
 */
export const DUE_PRESET_DAYS = [7, 15, 30, 60] as const;
export type DuePresetDays = (typeof DUE_PRESET_DAYS)[number];

/** Data local (sem deslocamento UTC) em YYYY-MM-DD, N dias à frente. */
export function dateMaisDias(dias: number, base: Date = new Date()): string {
  const d = new Date(base.getFullYear(), base.getMonth(), base.getDate() + dias);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export function DueDateField({
  value,
  onChange,
  disabled,
  inputClass,
  presetLabel,
}: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  inputClass: string;
  presetLabel: (days: DuePresetDays) => string;
}) {
  // Padrão 30 dias — só na abertura, sem sobrescrever o que o operador digitou.
  useEffect(() => {
    if (!value) onChange(dateMaisDias(30));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const ativo = DUE_PRESET_DAYS.find((d) => dateMaisDias(d) === value) ?? null;
  return (
    <div className="space-y-2">
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={inputClass}
        data-testid="due-date"
      />
      <div className="flex flex-wrap gap-1.5" role="group" aria-label="due-presets">
        {DUE_PRESET_DAYS.map((d) => (
          <button
            key={d}
            type="button"
            disabled={disabled}
            onClick={() => onChange(dateMaisDias(d))}
            data-testid={`due-preset-${d}`}
            aria-pressed={ativo === d}
            className={`rounded-md border px-2 py-0.5 text-xs transition-colors disabled:opacity-40 ${
              ativo === d
                ? "border-lime bg-lime/15 text-lime"
                : "border-neutral-700 text-text-secondary hover:border-lime hover:text-lime"
            }`}
          >
            {presetLabel(d)}
          </button>
        ))}
      </div>
    </div>
  );
}
